import { all } from "redux-saga/effects";
import settingSagas from "./settings/saga";
import authSagas from "./auth/saga";
import customerInvoiceSagas from "./customerInvoice/saga";
import scriptionPlanSagas from "./scriptionPlan/saga";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    settingSagas(),
    customerInvoiceSagas(),
    scriptionPlanSagas(),
  ]);
}
